<template>
  <div class="col-lg-12">
    <div class="main-card mb-3 card">
      <div class="card-body">


        <h5 class="card-title"  >강사 리스트
        </h5>
        <div class="sub_title" >클래스를 담당할 강사 계정을 등록하고 수정할수 있습니다.<br /> 강사은 여러 클래스를 담당할수 있습니다.</div>
        <query-grid :config="config" ref="qg">
          <template #items="props">
            <tr v-for="record in props.records" v-bind:key="record.id">
              <th scope="row">T-0{{ record.id }}</th>
              <td>{{ record.username }}</td>
              <td><admin :admin="record" :ref="'admusr' + record.id"/></td>
                            <td>
                <div style="display: block;padding-bottom: 2px;text-align:left" v-for="(bizes, bi) in record.businessDetail" :key="bi">
                    <Business v-for="biz in bizes" :key="biz.id" :biz="biz" />
                </div>
              </td>
              <td>{{ record.contact }}</td>
              <td>{{ record.suspended || '정상' }}</td>
              <td>
                <button class="btn btn-warning btn-sm" @click="this.$refs['admusr' + record.id][0].openModal()"  >수정</button>
                 <button class="btn btn-info btn-sm" @click="sudo(record);"  >로그인</button>
                <button class="btn btn-danger btn-sm" @click="deleteUser(record);">삭제</button>
              </td>
            </tr>
          </template>
          <template #actions>
            
        <button class="btn btn-danger" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg" @click="creatingMode()">강사 등록</button>
     
          </template>
        </query-grid>
        
        <div class="modal fade bd-example-modal-lg" tabindex="-1" id="adminModal" role="dialog" aria-labelledby="myLargeModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">강사 등록</h5>


              </div>
              <div class="modal-body">
<i class="fas fa-check-circle"></i> 필수입력

                <table class="table">
                  <tbody>
                    <tr>
                      <td class="th_bg">관리자코드</td>
                      <td>자동생성</td>
                      <td class="th_bg"><i class="fas fa-check-circle"></i>사용여부</td>
                      <td>
                        <div class="input-group mb-12">
                          <div class="input-group-prepend">
                            <select class="custom-select flex_center" id="inputGroupSelect01">
                              <option selected>선택</option>
                              <option value="1">사용</option>
                              <option value="2">미사용</option>
                            </select>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">관리범위</td>
                      <td colspan="3">
                        <tree-btn :tree="this.$refs.manageRange" />
                      </td>
                    </tr>


                  </tbody>
                </table>



                <table class="table">
                  <tbody>
                    <tr>
                      <td class="th_bg"><i class="fas fa-check-circle"></i>강사 아이디

                      </td>

                      <td><input class="hidtype" v-model="changedData.username " placeholder="아이디" />
                      </td>
                      <td class="th_bg"><i class="fas fa-check-circle"></i>비밀번호</td>
                      <td><input type="password" class="hidtype" v-model="changedData.password " placeholder="비밀번호" />
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">연락처</td>
                      <td><input class="hidtype" v-model="changedData.contact" placeholder="연락처" /></td>
                      <td class="th_bg">이메일</td>
                      <td><input class="hidtype" v-model="changedData.email " placeholder="이메일" /></td>
                    </tr>
                    <tr>
                      <td class="th_bg"><i class="fas fa-check-circle"></i>강사 이름</td>
                      <td><input class="hidtype" v-model="changedData.name "
                          placeholder="아이디" /></td>
                      <td class="th_bg"><i class="fas fa-check-circle"></i>영문명</td>
                      <td><input class="hidtype" v-model="changedData.engName " placeholder="아이디" /></td>
                    </tr>

                  </tbody>
                </table>

              </div>
              <div class="modal-footer flex_center">
                <button type="button" class="btn btn-danger" @click="doSend()">강사 등록</button>


                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">닫기</button>

              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>

  <Tree :key="$route.path" :selectable="['CLASS']" :tree-data="this.$root.businesses" multiple render-button :callback="selectedBiz" selected :selectedNodeIds="this.selData.bizIds" ref="manageRange"/>
</template>

<style>
  .hidtype {
    border: 0;
    text-align: center;
  }

  .hidtype-error {
    color: red;
  }

  .hidtype-changed {
    color: goldenrod;
  }
</style>

<script>
  // @ is an alias to /src

  import Tree from "../components/Tree";
  import Business from "../components/Business";
  import QueryGrid from "../components/QueryGrid";
  import VueCookies from 'vue-cookies';
  import axios from "axios";
  import TreeBtn from '../components/treeBtn.vue';
import Admin from '../components/detail_pages/Admin.vue';
  export default {
    name: 'Home',
    components: {
      Tree,
      Business,
      TreeBtn,
      QueryGrid,
        Admin
    },
    mounted() {


    },
    methods: {
      sudo(biz){
      let form = new FormData()
      form.append('grant_type', 'existing_session')
      form.append('id', biz.id)
      axios.post('/oauth/login', form)
        .then(response => {
          return new Promise((resolve) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '로그인할 수 없습니다. ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              VueCookies.set('access_token', response.data.access_token)
              VueCookies.set('refresh_token', response.data.refresh_token)
              $.notify({
                // options
                message: '권한 변경하여 로그인 되었습니다.'
              }, {
                // settings
                type: 'success',
                z_index: 9999
              });
              this.$root.is_logged_in = true;
              resolve(response.data)
            }
          })

        }).then(() => {
          this.$root.getBusinesses();
        })
      },
                  deleteUser(user){
              if(!confirm("정말로 삭제할까요")) return;
      axios.delete('/admins/' + user.id)
        .then(response => {
            if (response.data.error) {
              $.notify({
                // options
                message: '삭제할 수 없습니다. ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              $.notify({
                // options
                message: '삭제되었습니다.'
              }, {
                // settings
                type: 'success',
                z_index: 9999
              });
              resolve(response.data)
            }

        })
      },
      doChange(name, value) {
        if (this.selData[name] === value) {
          delete this.changedData[name];
        } else {
          this.changedData[name] = value;
        }
      },
      selectedBiz(biz) {
        this.selBiz = biz;
      },
      doSend() {
        // 업데이트일 경우 patch /businesses/번호
        // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
        var data = {
            ...this.selData,
            ...this.changedData,
            'grant': this.selBiz.join(",")
          };




        var send = {
          method: this.creating ? "post" : "patch",
          url: '/admins',
          data: data
        };

          axios(send).then((response) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '처리할 수 없습니다 ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              // 201 created 응답이 오면 계정 생성
              axios.post('/admins/' + response.data.id + '/grants', {
                grant: this.selBiz.join(",")
              }).then((response2) => {
                if (response2.data.error) {
                  $.notify({
                    // options
                    message: '처리할 수 없습니다 ' + response2.data.error
                  }, {
                    // settings
                    type: 'danger',
                    z_index: 9999
                  });
                } else {
                  // 마지막으로 grant

          (bootstrap.Modal.getInstance(document.getElementById("adminModal"))).hide();
                  $.notify({
                    // options
                    message: '처리되었습니다'
                  }, {
                    // settings
                    type: 'success',
                    z_index: 9999
                  });
this.$refs.qg.search()


                }
              })


            }


          })


      },
      creatingMode(){
        this.selData =  {
          "username": "",
          "password": "",
          "name": "",
          "engName": "",
          "contact": "",
          "email": "",
          "startDate": "",
          "endDate": ""
        }
        this.$refs.manageRange.reset([])
        this.changedData = {};
        this.creating = true;
      },
      modifyMode(record){
        this.creating = false;
        this.changedData = {};
        this.selData =  {
          "id": record.id,
          "username": record.username,
          "password": "****",
          "name": record.name,
          "engName": record.engName,
          "contact": record.contact,
          "email": record.email,
          "startDate": record.startDate.split(" ")[0],
          "endDate": record.endDate.split(" ")[0],
          "bizIds": record.bizIds
        }
        this.$refs.manageRange.reset(record.bizIds.split(", "));
      }
    },
    data() {
      return {
        records: [],
        selBiz: [],
        creating: true,
        selData: {
          "username": "",
          "password": "",
          "name": "",
          "engName": "",
          "contact": "",
          "email": "",
          "startDate": "",
          "endDate": ""
        },
        changedData: {

        },
        searchBiz: {},
        searchKeyword: "",
                config: {
    "name": "강사관리계정",
    "req_endpoint": "/admins",
    "default_limit": 20,
    "search_fields": [
        {
            "id": "businesses",
            "name": "소속선택",
            "type": "business" // business, date, datetime,
        },
        {
            "id": "status_filter",
            "name": "상태",
            "type": "switch",
            "filter_type": {
                "ACTIVE": "사용",
                "SUSPENDED": "미사용"
            }
        },
        {
            "id": "search",
            "name": "키워드검색",
            "type": "text",
            "placeholder": "이름/아이디/연락처로 검색"
        },
        {
            "id": "date",
            "name": "날짜검색",
            "type": "date",
            "filter_type": {
                "created_at": "생성일"
            }
        },
    ],
    "columns": [
        {
            "id": "id",
            "sortable": true,
            "name": "번호",
            "excel_print": v=>{return v.id}
        },
        {
            "id": "username",
            "sortable": true,
            "name": "아이디",
            "excel_print": v=>{return v.username}
        },
        {
            "id": "name",
            "sortable": true,
            "name": "이름",
            "excel_print": v=>{return v.name}
        },
                {
            "id": "parent",
            "name": "소속",
            "excel_print": v=>{return v.business}
        },
        {
            "id": "contact",
            "name": "연락처",
            "excel_print": v=>{return v.contact || ''}
        },
        
        {
            "id": "status",
            "sortable": true,
            "name": "상태",
            "excel_print": v=>{return v.suspended ? '미사용' : '사용'}
        },
        {
            "id": "action",
            "name": "작업"
        },
    ]
    ,
    "extras_addon": () => { return "&filter_type=[\"CLASS\"]"}
},
      }
    }
  }
</script>
